import { render } from "./ReferralsView.vue?vue&type=template&id=4ea66800"
import script from "./ReferralsView.vue?vue&type=script&lang=js"
export * from "./ReferralsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__